import {
  Box,
  Card,
  CardActions,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import { useFetchBulletinsQuery } from "../../../redux/bulletinApi";

interface BulletinContentProps {
  selectedTag: string | null;
  selectedTags: string[];
  searchQuery: string;
}

export const BulletinContent: React.FC<BulletinContentProps> = ({
  selectedTags,
  searchQuery,
}) => {
  const { data } = useFetchBulletinsQuery();

  // Function to highlight text occurrences for the search functionality
  const highlightText = (text: string, searchQuery: string) => {
    if (!searchQuery) return text;

    const regex = new RegExp(`(${searchQuery})`, "gi");
    return text.replace(
      regex,
      '<span style="background-color: yellow; color: black;">$1</span>'
    );
  };

  // Replace all instances of '<a' with a modified '<a' tag that has custom CSS styles.
  const renderShortDescription = (description: string) => {
    const descriptionWithStyles = description.replace(
      /<a /g,
      '<a style="color: #00AD99; text-decoration: none;" '
    );
    return { __html: highlightText(descriptionWithStyles, searchQuery) };
  };

  // Format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString().replace(/,/g, "");
  };

  console.log("data :: ", data);

  // Filter the data based on selected tags and search query
  const filteredData = data
    ? data.filter((article) => {
        const { title, shortDescription } = article;
        return (
          (selectedTags.length === 0 ||
            selectedTags.reduce(
              (included, tag) => included || article.tags.includes(tag),
              false
            )) &&
          (title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            shortDescription.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      })
    : [];

  return (
    <>
      <Box>
        {filteredData &&
          filteredData.map((article) => (
            <div key={article.id}>
              <Card
                className="articleCard"
                variant="outlined"
                sx={{ width: "100%", mx: "auto" }}
              >
                <CardContent>
                  <Typography
                    variant="h2"
                    fontWeight={100}
                    sx={{ pb: 1 }}
                    dangerouslySetInnerHTML={{
                      __html: highlightText(article.title, searchQuery),
                    }}
                  />
                  <Typography variant='h4' fontWeight={100} color="textSecondary">
                    Published Date: {formatDate(article.publishedDate)}
                  </Typography>
                  <Typography variant='h4' fontWeight={100} color="textSecondary">
                    Updated Date: {formatDate(article.updatedDate)}
                  </Typography>
                  <Typography variant='h4' fontWeight={100} color="textSecondary">
                    Category: {article.category}
                  </Typography>
                  <Typography variant='h4' fontWeight={100} color="textSecondary">
                    Severity: {article.severity}
                  </Typography>
                  <br />
                  <Typography
                    variant="body2"
                    dangerouslySetInnerHTML={renderShortDescription(
                      article.shortDescription
                    )}
                  />
                </CardContent>
                <CardActions disableSpacing>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={3}
                    sx={{ width: "100%" }}
                  >
                    <div style={{ width: "90%", margin: "5px" }}>
                      {article.tags
                        .slice(0, 5)
                        .sort((a, b) => a.localeCompare(b))
                        .map((tag, index) => (
                          <Chip key={index} label={tag} sx={{ margin: "5px" }} />
                        ))}
                    </div>
                    <Link
                      to={`${article.id}`}
                      style={{ textDecoration: "none", width: "15%" }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          color: "#00AD99",
                          "&:hover": {
                            color: "#00675b",
                          },
                        }}
                      >
                        View More
                      </Typography>
                    </Link>
                  </Stack>
                </CardActions>
              </Card>
              <br />
            </div>
          ))}
      </Box>
    </>
  );
};
